import axios from 'axios';
// config
import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    source: 'super-admin',
  },
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/api/v1/admin/',
    login: '/api/v1/admin/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  }, // mardam
  tenants: {
    list: '/api/v1/tenants/',
    create: '/api/v1/tenants/',
    delete: '/api/v1/tenants/',
    update: '/api/v1/tenants/',
  },
  subscriptions: {
    list: '/api/v1/tenants/getAllSubscriptionRequests/',
    approve: (id) => `/api/v1/tenants/${id}/subscription`,
    delete: (id) => `/api/v1/tenants/deleteRequest/${id}`,
  },
  dashboard: {
    getTotalPercentEntities: '/api/v1/dashboard/getTotalEntityCount',
    getTotalPercentActiveEntities: '/api/v1/dashboard/getActiveEntities',
    getWeightDetails: (value) => `/api/v1/dashboard/getWeightDetails?value=${value}`,
    getVehicleDetails: (value) => `/api/v1/dashboard/getVehicleDetails?value=${value}`,
    getVehicleWeightDetails: (value) => `/api/v1/dashboard/getVehicleWeightDetails?value=${value}`,
    getVehicleTypeDetails: (value) => `/api/v1/dashboard/getVehicleTypeDetails?value=${value}`,
    getTotalPickupPoints: () => `/api/v1/admin/dashboard/getTotalPickupPoints`,
    getTotalVehicles: () => `/api/v1/admin/dashboard/getTotalVehicles`,
    getTotalGarbageCollected: () => `/api/v1/admin/dashboard/getTotalGarbageCollected`,
    getTotalTenants: () => `/api/v1/admin/dashboard/getTotalTenants`,
    getActiveInactiveUsers: () => `/api/v1/admin/dashboard/getTotalTenantUsers`,
    getAdminVehicleWeightDetails: (value) => `/api/v1/admin/dashboard/getWeightGraphData?value=${value}`,
  },
};
